import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import "element-ui/lib/theme-chalk/index.css";

// 导入 ElementUI 语言包
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTwLocale from 'element-ui/lib/locale/lang/zh-TW'

// 导入自定义语言包
import enMessages from './en'
import zhMessages from './zh'
import zhTwMessages from './zhtw'

Vue.use(VueI18n)

// 合并语言包
const messages = {
  en: {
    ...enMessages,
    ...enLocale
  },
  zh: {
    ...zhMessages,
    ...zhLocale
  },
  zhtw: {
    ...zhTwMessages,
    ...zhTwLocale
  }
}

export function getLanguage() {
  const chooseLanguage = localStorage.getItem('language')
  if (chooseLanguage) return chooseLanguage

  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  
  // 更精确的语言检测
  if (language.includes('zh-tw') || language.includes('zh-hk') || language.includes('zh-mo')) {
    return 'zhtw'
  }
  if (language.includes('zh')) {
    return 'zh'
  }
  if (language.includes('en')) {
    return 'en'
  }
  
  return 'zh' // 默认中文
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages,
  silentTranslationWarn: true
})

// 关键：为 ElementUI 设置国际化
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

export default i18n